import { render, staticRenderFns } from "./StatusEdit.vue?vue&type=template&id=94460d58&scoped=true&"
import script from "./StatusEdit.vue?vue&type=script&lang=js&"
export * from "./StatusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94460d58",
  null
  
)

export default component.exports